import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex flex-column flex-column-fluid" }
const _hoisted_2 = { class: "card py-5 px-5 mb-3" }
const _hoisted_3 = { class: "d-flex justify-content-between" }
const _hoisted_4 = { class: "d-flex gap-3" }
const _hoisted_5 = { class: "d-flex gap-3" }
const _hoisted_6 = { class: "card" }
const _hoisted_7 = { class: "card-body py-4" }
const _hoisted_8 = { class: "table-responsive" }
const _hoisted_9 = { class: "table align-middle table-row-dashed fs-6 gy-5" }
const _hoisted_10 = { class: "text-start text-muted fw-bold fs-7 text-uppercase gs-0" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = {
  key: 2,
  class: "fw-semibold text-gray-900"
}
const _hoisted_14 = { class: "text-muted" }
const _hoisted_15 = { class: "fs-6 fw-semibold mb-2 d-block" }
const _hoisted_16 = { class: "fs-6 fw-semibold mb-2 d-block" }
const _hoisted_17 = { class: "fs-6 fw-semibold mb-2 d-block" }
const _hoisted_18 = { class: "fs-6 fw-semibold mb-2 d-block" }
const _hoisted_19 = { class: "fs-6 fw-semibold mb-2 d-block" }
const _hoisted_20 = { class: "mb-4" }
const _hoisted_21 = { class: "fs-6 fw-semibold mb-2 d-block" }
const _hoisted_22 = { class: "fs-6 fw-semibold mb-2 d-block" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", { class: "text-muted fw-normal" }, "（1～100）", -1)

import { ref, computed, onMounted, provide } from "vue";
import { useI18n } from "vue-i18n";
import moment from "moment";
import HeaderMenu from "../components/HeaderMenu.vue";
import svc from "../services/PaymentService";
import MsgPrompt from "@/core/plugins/MsgPrompt";

enum ReceivableTabType {
  Assigned = 1,
  Unassigned = 2,
  All = 0,
}

export default /*#__PURE__*/_defineComponent({
  __name: 'ReceivingAccountIndex',
  setup(__props) {

const { t } = useI18n();

// 收款账号 tabs：已分配 / 未分配 / 全部
const TabStatus = ReceivableTabType;

const isLoading = ref(false);
provide("isLoading", isLoading);

const headerMenuRef = ref<InstanceType<typeof HeaderMenu>>();
const tab = ref<ReceivableTabType>(ReceivableTabType.Assigned);
const data = ref<any[]>([]);

const criteria = ref<any>({
  page: 1,
  size: 10,
  searchText: "",
});

// 不放进动态列的字段（user→客户列、accountNumber→第二列单独渲染）
const HIDDEN_COLUMNS = [
  "id",
  "expiresOn",
  "createdOn",
  "updatedOn",
  "user",
  "accountNumber",
  "assignedPartyId",
  "assignedAccountId",
  "lookupKey",
];
const columns = computed<string[]>(() =>
  data.value.length > 0
    ? Object.keys(data.value[0]).filter((k) => !HIDDEN_COLUMNS.includes(k))
    : []
);

// 动态列表头的多语言映射（未列出的列保留原始字段名）
const COLUMN_LABELS: Record<string, string> = {
  type: "fields.type",
  lookupKey: "fields.lookupKey",
  assignedPartyId: "fields.partyId",
  assignedAccountId: "fields.accountId",
  isActive: "status.active",
  assignedOn: "fields.assignedOn",
  data: "fields.data",
};
const columnLabel = (col: string) =>
  COLUMN_LABELS[col] ? t(COLUMN_LABELS[col]) : col;

// data 内字段的多语言（按小写 key 匹配，兼容大小写写法）
const DATA_FIELD_LABELS: Record<string, string> = {
  clientuniqueid: "fields.clientUniqueId",
  bankaccountname: "fields.bankAccountName",
  bankaccountnumber: "fields.bankAccountNumber",
  bsb: "fields.bsb",
  payid: "fields.payId",
};
const dataFieldLabel = (key: string) => {
  const mapped = DATA_FIELD_LABELS[String(key).toLowerCase()];
  return mapped ? t(mapped) : key;
};

const formatCell = (value: any) => {
  if (value === null || value === undefined) return "";
  if (typeof value === "object") return JSON.stringify(value);
  return value;
};

const formatDateTime = (value: any) => {
  if (!value) return "";
  const d = moment(value);
  return d.isValid() ? d.format("YYYY-MM-DD HH:mm:ss") : value;
};

// 该行是否已分配（“全部”tab 下有 assignedPartyId 即为已分配）
const isRowAssigned = (item: any) => {
  if (tab.value === ReceivableTabType.Assigned) return true;
  if (tab.value === ReceivableTabType.Unassigned) return false;
  return !!item.assignedPartyId;
};

// 根据当前 tab 设置 isAssigned：已分配=true、未分配=false、全部=不传
const applyTabToCriteria = () => {
  if (tab.value === ReceivableTabType.Assigned) {
    criteria.value.isAssigned = true;
  } else if (tab.value === ReceivableTabType.Unassigned) {
    criteria.value.isAssigned = false;
  } else {
    delete criteria.value.isAssigned;
  }
};

const changeTab = (_tab: ReceivableTabType) => {
  tab.value = _tab;
  fetchData(1);
};

const fetchData = async (_page: number) => {
  applyTabToCriteria();
  criteria.value.page = _page;
  isLoading.value = true;
  try {
    const res = await svc.queryPaymentReceivables(criteria.value);
    criteria.value = res.criteria;
    data.value = res.data;
  } catch (error) {
    console.error("Error fetching payment receivable data:", error);
    data.value = [];
    criteria.value = {
      ...criteria.value,
      total: 0,
      pageCount: 1,
      hasMore: false,
    };
  } finally {
    isLoading.value = false;
  }
};

const pageChange = (page: number) => {
  fetchData(page);
};

const confirmSearch = () => {
  // 搜索后直接跳到“全部”tab（changeTab 会触发 fetchData）
  headerMenuRef.value?.changeTab(ReceivableTabType.All);
};

const clearSearch = () => {
  criteria.value.searchText = "";
  fetchData(1);
};

// 入金弹窗
const depositVisible = ref(false);
const depositing = ref(false);
const depositRow = ref<any>(null);
const depositForm = ref<{ usePayId: boolean; amount: string }>({
  usePayId: true,
  amount: "",
});

// 从 data 里按 key 取值（兼容大小写写法）
const getDataField = (data: any, name: string) => {
  if (!data) return undefined;
  const lower = name.toLowerCase();
  const key = Object.keys(data).find((k) => k.toLowerCase() === lower);
  return key ? data[key] : undefined;
};

const depositPayId = computed(
  () => getDataField(depositRow.value?.data, "payId") ?? ""
);
const depositBankAccountNumber = computed(
  () => getDataField(depositRow.value?.data, "bankAccountNumber") ?? ""
);
const depositBsb = computed(
  () => getDataField(depositRow.value?.data, "bsb") ?? ""
);

const openDeposit = (item: any) => {
  depositRow.value = item;
  depositForm.value = { usePayId: true, amount: "" };
  depositVisible.value = true;
};

const confirmDeposit = async () => {
  const amount = Number(depositForm.value.amount);
  if (!amount) {
    MsgPrompt.warning(t("title.fillRequiredInfo"));
    return;
  }
  const data = depositRow.value?.data || {};
  depositing.value = true;
  try {
    await svc.testDepositAud({
      usePayId: depositForm.value.usePayId,
      payId: getDataField(data, "payId"),
      bankAccountNumber: getDataField(data, "bankAccountNumber"),
      bsb: getDataField(data, "bsb"),
      amount,
    });
    MsgPrompt.success(t("status.success"));
    depositVisible.value = false;
    fetchData(criteria.value.page || 1);
  } catch (error) {
    MsgPrompt.error(error);
  } finally {
    depositing.value = false;
  }
};

// 新建弹窗
const createVisible = ref(false);
const creating = ref(false);
const createForm = ref<{ methodId: string; count: string }>({
  methodId: "",
  count: "",
});

const openCreate = () => {
  createForm.value = { methodId: "", count: "" };
  createVisible.value = true;
};

const confirmCreate = async () => {
  const methodId = Number(createForm.value.methodId);
  const count = Number(createForm.value.count);
  if (!methodId || !count) {
    MsgPrompt.warning(t("title.fillRequiredInfo"));
    return;
  }
  creating.value = true;
  try {
    await svc.provisionPaymentReceivable({ methodId, count });
    MsgPrompt.success(t("status.success"));
    createVisible.value = false;
    fetchData(1);
  } catch (error) {
    MsgPrompt.error(error);
  } finally {
    creating.value = false;
  }
};

onMounted(() => {
  fetchData(1);
});

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_LoadingRing = _resolveComponent("LoadingRing")!
  const _component_NoDataBox = _resolveComponent("NoDataBox")!
  const _component_UserInfo = _resolveComponent("UserInfo")!
  const _component_TableFooter = _resolveComponent("TableFooter")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(HeaderMenu, {
      tabs: _unref(TabStatus),
      onChangeTab: changeTab,
      ref_key: "headerMenuRef",
      ref: headerMenuRef
    }, null, 8, ["tabs"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_el_input, {
            modelValue: criteria.value.searchText,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((criteria.value.searchText) = $event)),
            class: "w-200px",
            placeholder: _ctx.$t('fields.keyword'),
            clearable: ""
          }, null, 8, ["modelValue", "placeholder"]),
          _createVNode(_component_el_button, {
            plain: "",
            type: "primary",
            onClick: confirmSearch
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("action.search")), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            plain: "",
            type: "info",
            onClick: clearSearch
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("action.clear")), 1)
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_5, [
          (tab.value === _unref(TabStatus).Unassigned)
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 0,
                type: "primary",
                onClick: openCreate
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("action.new")), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("table", _hoisted_9, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", _hoisted_10, [
                _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.client")), 1),
                _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.partyId")), 1),
                _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.accountId")), 1),
                _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.accountNumber")), 1),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(columns.value, (col) => {
                  return (_openBlock(), _createElementBlock("th", { key: col }, _toDisplayString(columnLabel(col)), 1))
                }), 128))
              ])
            ]),
            (isLoading.value)
              ? (_openBlock(), _createElementBlock("tbody", _hoisted_11, [
                  _createVNode(_component_LoadingRing)
                ]))
              : (data.value.length === 0)
                ? (_openBlock(), _createElementBlock("tbody", _hoisted_12, [
                    _createVNode(_component_NoDataBox)
                  ]))
                : (_openBlock(), _createElementBlock("tbody", _hoisted_13, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.value, (item, index) => {
                      return (_openBlock(), _createElementBlock("tr", { key: index }, [
                        _createElementVNode("td", null, [
                          (item.user)
                            ? (_openBlock(), _createBlock(_component_UserInfo, {
                                key: 0,
                                user: item.user,
                                partyId: item.assignedPartyId
                              }, null, 8, ["user", "partyId"]))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("td", null, _toDisplayString(formatCell(item.assignedPartyId)), 1),
                        _createElementVNode("td", null, _toDisplayString(formatCell(item.assignedAccountId)), 1),
                        _createElementVNode("td", null, _toDisplayString(formatCell(item.accountNumber)), 1),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(columns.value, (col) => {
                          return (_openBlock(), _createElementBlock("td", { key: col }, [
                            (col === 'data')
                              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(item.data || {}, (val, key) => {
                                  return (_openBlock(), _createElementBlock("div", { key: key }, [
                                    _createElementVNode("span", _hoisted_14, _toDisplayString(dataFieldLabel(key)) + ":", 1),
                                    _createTextVNode(" " + _toDisplayString(formatCell(val)), 1)
                                  ]))
                                }), 128))
                              : (col === 'assignedOn')
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    _createTextVNode(_toDisplayString(formatDateTime(item[col])), 1)
                                  ], 64))
                                : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                    _createTextVNode(_toDisplayString(formatCell(item[col])), 1)
                                  ], 64))
                          ]))
                        }), 128))
                      ]))
                    }), 128))
                  ]))
          ])
        ]),
        _createVNode(_component_TableFooter, {
          onPageChange: pageChange,
          criteria: criteria.value
        }, null, 8, ["criteria"])
      ])
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: depositVisible.value,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((depositVisible).value = $event)),
      title: _ctx.$t('title.deposit'),
      width: "420",
      "align-center": ""
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          onClick: _cache[3] || (_cache[3] = ($event: any) => (depositVisible.value = false))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("action.cancel")), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          loading: depositing.value,
          onClick: confirmDeposit
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("action.confirm")), 1)
          ]),
          _: 1
        }, 8, ["loading"])
      ]),
      default: _withCtx(() => [
        _createElementVNode("label", _hoisted_15, _toDisplayString(_ctx.$t("fields.usePayId")), 1),
        _createVNode(_component_el_radio_group, {
          modelValue: depositForm.value.usePayId,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((depositForm.value.usePayId) = $event)),
          class: "mb-4"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_radio, { label: true }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("action.yes")), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_radio, { label: false }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("action.no")), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"]),
        (depositForm.value.usePayId)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("label", _hoisted_16, _toDisplayString(_ctx.$t("fields.payId")), 1),
              _createVNode(_component_el_input, {
                "model-value": depositPayId.value,
                disabled: "",
                class: "mb-4"
              }, null, 8, ["model-value"])
            ], 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createElementVNode("label", _hoisted_17, _toDisplayString(_ctx.$t("fields.bankAccountNumber")), 1),
              _createVNode(_component_el_input, {
                "model-value": depositBankAccountNumber.value,
                disabled: "",
                class: "mb-4"
              }, null, 8, ["model-value"]),
              _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.$t("fields.bsb")), 1),
              _createVNode(_component_el_input, {
                "model-value": depositBsb.value,
                disabled: "",
                class: "mb-4"
              }, null, 8, ["model-value"])
            ], 64)),
        _createElementVNode("label", _hoisted_19, _toDisplayString(_ctx.$t("fields.amount")), 1),
        _createVNode(_component_el_input, {
          modelValue: depositForm.value.amount,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((depositForm.value.amount) = $event)),
          placeholder: _ctx.$t('fields.amount')
        }, null, 8, ["modelValue", "placeholder"])
      ]),
      _: 1
    }, 8, ["modelValue", "title"]),
    _createVNode(_component_el_dialog, {
      modelValue: createVisible.value,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((createVisible).value = $event)),
      title: _ctx.$t('title.createReceivingAccount'),
      width: "480",
      "align-center": ""
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          onClick: _cache[7] || (_cache[7] = ($event: any) => (createVisible.value = false))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("action.cancel")), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          loading: creating.value,
          onClick: confirmCreate
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("action.create")), 1)
          ]),
          _: 1
        }, 8, ["loading"])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("label", _hoisted_21, _toDisplayString(_ctx.$t("fields.paymentMethodId")), 1),
          _createVNode(_component_el_input, {
            modelValue: createForm.value.methodId,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((createForm.value.methodId) = $event))
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("label", _hoisted_22, [
            _createTextVNode(_toDisplayString(_ctx.$t("fields.quantity")) + " ", 1),
            _hoisted_23
          ]),
          _createVNode(_component_el_input, {
            modelValue: createForm.value.count,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((createForm.value.count) = $event))
          }, null, 8, ["modelValue"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "title"])
  ]))
}
}

})